<template>
    <div class="job-warp">
            <div class="job-warp-header">
                <span class="fl">岗位管理</span>
                <el-button class="fr ml10 mt10" type="primary" @click="exportJobFn">导出岗位用户</el-button>
                <el-button class="fr mt10" type="primary" @click="importJobFn">导入岗位用户</el-button>
                <el-button class="fr mt10" @click="downloadTemplate">模板下载</el-button>
            </div>
        <div class="w100 pl10 pr10 pb10 flex-box job">
            <div class="mr20 flex-box flex-col job-left bor">
                <leftJobList
                        ref="leftJobList"
                        @handleAdd="openAddDialog"
                        @selectJob="selectJob"
                        @openDetailFn="openDetailFn"/>
            </div>
            <div class="flex-1 w100 h100 job-right bor"  >
                <rightList ref="rightList" />
            </div>
        </div>
        <addJobDialog ref="addJobDialogRef" @saveSuccess="saveSuccess"/>
        <importExcel
                ref="uplodModal"
                :uplodData="uplodData"
                @closeUplod="closeUplod"
                @successCallBack="saveSuccess"
        ></importExcel>
    </div>
</template>

<script>
    import leftJobList from "@/components/management/job/leftJobList";
    import rightList from "@/components/management/job/rightList";
    import addJobDialog from "@/components/management/job/addJobDialog";
    import { getJobInfo} from '@/api/managementCenter/jobManage';
    import * as serve from '@/api/importAndExport/excelApi';
    import importExcel from "@/components/dialog/deptManage/importExcel.vue";

    export default {
        name: "Job",
        components: {
            leftJobList,
            addJobDialog,
            rightList,
            importExcel
        },
        props: [],
        data() {
            return {
                addDialogShow:false,
                uplodData: {
                    state: false,
                    type: ""
                },
            }
        },
        computed: {

        },
        mounted() {},
        methods: {
            openDetailFn(item){
                this.loading = true;
                getJobInfo(item.postId).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0){

                        this.$refs.addJobDialogRef.dialogShow('edit',data.data||{})

                    }else{
                        this.$message.warning( data.msg||"获取岗位信息失败！" );
                    }
                }).catch(err=>{
                    this.loading = false;
                })




            },
            selectJob(item){
                this.$refs.rightList.loadListFn(item.postId);
            },
            openAddDialog(){
              this.$refs.addJobDialogRef.dialogShow('add')
            },
            saveSuccess(){
                this.$refs.leftJobList.getJobListFn();
            },
            exportJobFn(){
                this.downloadFn(serve.excelExport('userpost'));

            },
            importJobFn(){
                this.uplodData.state = true;
                this.uplodData.type = "userpost";
            },
            downloadTemplate(){
                this.downloadFn(serve.downloadTemplate('userpost'));
            },
            closeUplod(val) {
                this.uplodData.state = val;
            },
            downloadFn(url){
                console.log(url,'uri');
                this.$DownLoad(
                    url,
                    null,
                    res => {
                        if (res.status == 200) {
                        } else {
                            this.$alert("下载出错,请稍后重试", "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    },
                    error => {
                        this.$alert(error, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                );

            },

        },
        watch: {

        },
        filters: {}
    };
</script>

<style scoped lang="less">
    .job-warp{
        width: 100%;
        &-header{
            height: 50px;
            width: 100%;
            line-height: 50px;
            padding: 0 10px;
            >span{
                font-weight: bold;
                color: #409EFF;
                font-size: 16px;
                display: inline-block;
                height: 50px;
                line-height: 50px;
                /*display: none;*/
            }
        }
        .job{
            width: 100%;
            height: calc(100vh - 160px);
            &-left{
                width: 260px;
            }
            &-right{
                display: flex;
                flex-direction: column;
                overflow: hidden;

            }

        }
    }

</style>
